import { environment } from '@app/env';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppPopoversService } from '../../app-popovers/app-popovers.service';
import { ProfileService } from '../../services/profile.service';
import { AppFooterService } from '../../app-footer/app-footer.service';

@Component({
  selector: 'app-footer-touch',
  styleUrls: ['app-footer-touch.component.scss'],
  templateUrl: './app-footer-touch.component.html',
})
export class AppFooterTouchComponent implements OnInit, OnDestroy {
  public mobileFooterVisible: boolean;

  public env = environment;

  constructor(
    private appPopoversService: AppPopoversService,
    private profileService: ProfileService,
    private appFooterService: AppFooterService
  ) {}

  ngOnInit(): void {
    this.appFooterService.stream().subscribe((res) => {
      switch (res.action) {
        case 'OPEN':
          this.openFooter();
          break;
        case 'CLOSE':
          this.closeFooter();
          break;
        default:
          break;
      }
    });
  }
  public showPopup(id) {
    this.appPopoversService.open(id);
  }
  public openFooter(): void {
    this.mobileFooterVisible = true;
  }
  public closeFooter(): void {
    this.mobileFooterVisible = false;
  }
  ngOnDestroy(): void {
    this.appFooterService.hide();
    this.closeFooter();
    this.appPopoversService.close('all');
  }
}
